"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getViewVersion = exports.getEntitiesDdlVersion = exports.EntityColumnIterator = exports.getEntityColumns = exports.EntityMixedColumnDescription = void 0;
const typeorm_1 = require("typeorm");
const objectHash = __importStar(require("object-hash"));
const types_1 = require("../data-ui/types");
const StringUtils_1 = require("typeorm/util/StringUtils");
class EntityMixedColumnDescription extends types_1.AbstractEntityColumnDescription {
    constructor(columnMetadata, metadataArgs) {
        super();
        this.columnMetadata = columnMetadata;
        this.metadataArgs = metadataArgs;
    }
    get databaseName() {
        var _a, _b, _c, _d, _e, _f;
        return ((_e = (_b = (_a = this.columnMetadata) === null || _a === void 0 ? void 0 : _a.databaseName) !== null && _b !== void 0 ? _b : (_d = (_c = this.metadataArgs) === null || _c === void 0 ? void 0 : _c.options) === null || _d === void 0 ? void 0 : _d.name) !== null && _e !== void 0 ? _e : (0, StringUtils_1.snakeCase)((_f = this.metadataArgs) === null || _f === void 0 ? void 0 : _f.propertyName));
    }
    get propertyName() {
        var _a, _b, _c;
        return (_b = (_a = this.columnMetadata) === null || _a === void 0 ? void 0 : _a.propertyName) !== null && _b !== void 0 ? _b : (_c = this.metadataArgs) === null || _c === void 0 ? void 0 : _c.propertyName;
    }
    get propertyPath() {
        return;
    }
    get isReadOnly() {
        var _a;
        return (((_a = this.columnMetadata) === null || _a === void 0 ? void 0 : _a.isGenerated) ||
            this.isCreateDate ||
            this.isUpdateDate ||
            this.isDeleteDate);
    }
    get isGenerated() {
        var _a;
        return (_a = this.columnMetadata) === null || _a === void 0 ? void 0 : _a.isGenerated;
    }
    get isCreateDate() {
        var _a;
        return (_a = this.columnMetadata) === null || _a === void 0 ? void 0 : _a.isCreateDate;
    }
    get isUpdateDate() {
        var _a;
        return (_a = this.columnMetadata) === null || _a === void 0 ? void 0 : _a.isUpdateDate;
    }
    get isDeleteDate() {
        var _a;
        return (_a = this.columnMetadata) === null || _a === void 0 ? void 0 : _a.isDeleteDate;
    }
    get isNullable() {
        var _a;
        return (_a = this.columnMetadata) === null || _a === void 0 ? void 0 : _a.isNullable;
    }
    get hasDefaultValue() {
        var _a, _b;
        return (((_a = this.columnMetadata) === null || _a === void 0 ? void 0 : _a.default) !== undefined ||
            ((_b = this.columnMetadata) === null || _b === void 0 ? void 0 : _b.isGenerated));
    }
    get defaultValue() {
        var _a;
        return (_a = this.columnMetadata) === null || _a === void 0 ? void 0 : _a.default;
    }
    get isPrimary() {
        var _a;
        return (_a = this.columnMetadata) === null || _a === void 0 ? void 0 : _a.isPrimary;
    }
    get isArray() {
        var _a;
        return (_a = this.columnMetadata) === null || _a === void 0 ? void 0 : _a.isArray;
    }
    get columnType() {
        var _a;
        const type = (_a = this.columnMetadata) === null || _a === void 0 ? void 0 : _a.type;
        if (!type) {
            return;
        }
        if (types_1.AbstractEntityColumnDescription.integerColumnTypes.has(type)) {
            return {
                type: types_1.SimplifiedColumnTypeEnum.INTEGER,
            };
        }
        if (types_1.AbstractEntityColumnDescription.floatColumnTypes.has(type)) {
            return {
                type: types_1.SimplifiedColumnTypeEnum.FLOAT,
            };
        }
        if (types_1.AbstractEntityColumnDescription.precisionColumnTypes.has(type)) {
            return {
                type: types_1.SimplifiedColumnTypeEnum.PRECISION,
                precision: this.columnMetadata.precision,
                scale: this.columnMetadata.scale,
            };
        }
        if (types_1.AbstractEntityColumnDescription.textColumnTypes.has(type)) {
            return {
                type: types_1.SimplifiedColumnTypeEnum.TEXT,
                length: parseInt(this.columnMetadata.length) || null,
            };
        }
        if (types_1.AbstractEntityColumnDescription.jsonColumnTypes.has(type)) {
            return {
                type: types_1.SimplifiedColumnTypeEnum.JSON,
            };
        }
        if (type === 'boolean' || type === 'bool') {
            return {
                type: types_1.SimplifiedColumnTypeEnum.BOOLEAN,
            };
        }
        if (type === 'enum' || type === 'simple-enum') {
            return {
                type: types_1.SimplifiedColumnTypeEnum.ENUM,
            };
        }
        if (type === 'datetime') {
            return {
                type: types_1.SimplifiedColumnTypeEnum.DATETIME,
            };
        }
        if (type === 'uuid') {
            return {
                type: types_1.SimplifiedColumnTypeEnum.UUID,
            };
        }
    }
    get enumValues() {
        var _a;
        return (_a = this.columnMetadata) === null || _a === void 0 ? void 0 : _a.enum;
    }
    get isRelation() {
        var _a;
        return !!((_a = this.columnMetadata) === null || _a === void 0 ? void 0 : _a.relationMetadata);
    }
    get isRelationOwner() {
        var _a, _b;
        return !!((_b = (_a = this.columnMetadata) === null || _a === void 0 ? void 0 : _a.relationMetadata) === null || _b === void 0 ? void 0 : _b.isOwning);
    }
    get relationType() {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        if ((_b = (_a = this.columnMetadata) === null || _a === void 0 ? void 0 : _a.relationMetadata) === null || _b === void 0 ? void 0 : _b.isOneToOne) {
            return types_1.SimplifiedRelationType.ONE_TO_ONE;
        }
        if ((_d = (_c = this.columnMetadata) === null || _c === void 0 ? void 0 : _c.relationMetadata) === null || _d === void 0 ? void 0 : _d.isOneToMany) {
            return types_1.SimplifiedRelationType.ONE_TO_MANY;
        }
        if ((_f = (_e = this.columnMetadata) === null || _e === void 0 ? void 0 : _e.relationMetadata) === null || _f === void 0 ? void 0 : _f.isManyToOne) {
            return types_1.SimplifiedRelationType.MANY_TO_ONE;
        }
        if ((_h = (_g = this.columnMetadata) === null || _g === void 0 ? void 0 : _g.relationMetadata) === null || _h === void 0 ? void 0 : _h.isManyToMany) {
            return types_1.SimplifiedRelationType.MANY_TO_MANY;
        }
    }
    get relationReferencedColumn() {
        throw new Error('[relationReferencedColumn] Method not implemented.');
    }
    get relationEntity() {
        var _a, _b, _c;
        return (_c = (_b = (_a = this.columnMetadata) === null || _a === void 0 ? void 0 : _a.relationMetadata) === null || _b === void 0 ? void 0 : _b.entityMetadata) === null || _c === void 0 ? void 0 : _c.target;
    }
    get isEagerRelation() {
        var _a, _b;
        return (_b = (_a = this.columnMetadata) === null || _a === void 0 ? void 0 : _a.relationMetadata) === null || _b === void 0 ? void 0 : _b.isEager;
    }
    get relationInverseSidePropertyPath() {
        var _a, _b;
        return (_b = (_a = this.columnMetadata) === null || _a === void 0 ? void 0 : _a.relationMetadata) === null || _b === void 0 ? void 0 : _b.inverseSidePropertyPath;
    }
    get isCascadeRelation() {
        return this.cascadeRelations !== undefined;
    }
    get isEmbed() {
        return !!this.columnMetadata.embeddedMetadata;
    }
    get cascadeRelations() {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        const result = {
            insert: (_b = (_a = this.columnMetadata) === null || _a === void 0 ? void 0 : _a.relationMetadata) === null || _b === void 0 ? void 0 : _b.isCascadeInsert,
            update: (_d = (_c = this.columnMetadata) === null || _c === void 0 ? void 0 : _c.relationMetadata) === null || _d === void 0 ? void 0 : _d.isCascadeUpdate,
            remove: (_f = (_e = this.columnMetadata) === null || _e === void 0 ? void 0 : _e.relationMetadata) === null || _f === void 0 ? void 0 : _f.isCascadeRemove,
            softRemove: (_h = (_g = this.columnMetadata) === null || _g === void 0 ? void 0 : _g.relationMetadata) === null || _h === void 0 ? void 0 : _h.isCascadeSoftRemove,
            recover: (_k = (_j = this.columnMetadata) === null || _j === void 0 ? void 0 : _j.relationMetadata) === null || _k === void 0 ? void 0 : _k.isCascadeSoftRemove,
        };
        if (Object.values(result).every((flag) => !flag)) {
            return undefined;
        }
        return result;
    }
    get embeds() {
        return;
    }
}
exports.EntityMixedColumnDescription = EntityMixedColumnDescription;
function getEntityColumns(entity, connection) {
    if (!connection) {
        connection = (0, typeorm_1.getConnection)();
    }
    if (connection.hasMetadata(entity)) {
        return connection
            .getMetadata(entity)
            .columns.map((columnMetadata) => new EntityMixedColumnDescription(columnMetadata));
    }
    const metadataArgsStorage = (0, typeorm_1.getMetadataArgsStorage)();
    const columns = metadataArgsStorage.columns.filter((value) => value.target === entity);
    return columns.map((columnMetadataArgs) => new EntityMixedColumnDescription(undefined, columnMetadataArgs));
}
exports.getEntityColumns = getEntityColumns;
class EntityColumnIterator {
    constructor(alreadyVisited) {
        if (alreadyVisited) {
            this.visited = { ...alreadyVisited };
        }
        else {
            this.visited = {};
        }
    }
    forceAll(columns, visitor) {
        for (const column of columns) {
            const columnName = column.databaseName;
            visitor(columnName, column);
            this.visited[columnName] = true;
        }
    }
    all(columns, visitor) {
        for (const column of columns) {
            const columnName = column.databaseName;
            if (this.visited[columnName]) {
                continue;
            }
            visitor(columnName, column);
            this.visited[columnName] = true;
        }
    }
}
exports.EntityColumnIterator = EntityColumnIterator;
function getEntitiesDdlVersion(entities, connection) {
    if (!connection) {
        connection = (0, typeorm_1.getConnection)();
    }
    const metadatas = entities
        .map((entity) => entity instanceof typeorm_1.EntityMetadata
        ? entity
        : connection.getMetadata(entity))
        .sort((a, b) => a.name.localeCompare(b.name));
    const columnDatabaseNames = metadatas.flatMap((metadata) => [
        `t:${metadata.tablePath}`,
        ...metadata.ownColumns.map((c) => {
            var _a, _b;
            const normalizedType = connection.driver.normalizeType(c);
            if (c.type === 'enum') {
                const enumValues = (_b = (_a = c.enum) === null || _a === void 0 ? void 0 : _a.sort().join(',')) !== null && _b !== void 0 ? _b : '';
                return `c:${c.databaseName}:${normalizedType}:${enumValues}`;
            }
            return `c:${c.databaseName}:${normalizedType}`;
        }),
    ]);
    return {
        columns: columnDatabaseNames,
        hash: objectHash.MD5(columnDatabaseNames),
    };
}
exports.getEntitiesDdlVersion = getEntitiesDdlVersion;
function getViewVersion(view, entities, connection) {
    var _a, _b, _c;
    if (view instanceof typeorm_1.SelectQueryBuilder) {
        const qbEntities = [
            ((_a = view.expressionMap.mainAlias) === null || _a === void 0 ? void 0 : _a.hasMetadata)
                ? (_b = view.expressionMap.mainAlias) === null || _b === void 0 ? void 0 : _b.metadata
                : null,
            ...(_c = view.expressionMap.joinAttributes) === null || _c === void 0 ? void 0 : _c.map((ja) => ja.alias.hasMetadata ? ja.alias.metadata : null),
            ...(entities !== null && entities !== void 0 ? entities : []),
        ].filter((e) => e);
        return getEntitiesDdlVersion(qbEntities, connection);
    }
    else {
        return getEntitiesDdlVersion(entities !== null && entities !== void 0 ? entities : [], connection);
    }
}
exports.getViewVersion = getViewVersion;
//# sourceMappingURL=entity.js.map